import React, { ButtonHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

const classes = {
  primary: 'bg-primary text-secondary-50',
  'primary-outline': 'border border-primary text-primary-900 bg-transparent',
  secondary: 'bg-primary-100 text-primary-900',
  tertiary: 'bg-secondary-200 text-primary-900',
  danger: 'bg-secondary text-primary-900',
  'danger-v2': 'bg-danger text-secondary-50',
  'danger-v3': 'bg-danger text-secondary-50 rounded-[8px]',
  'primary-dark': 'bg-primary-900 text-secondary-50 rounded-[8px]',
};

type ButtonProps = {
  variant?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'primary-outline'
    | 'danger'
    | 'danger-v2'
    | 'danger-v3'
    | 'primary-dark';
  className?: string;
  loading?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export default function Button({
  variant,
  className = '',
  children,
  loading = false,
  ...props
}: ButtonProps): JSX.Element {
  return (
    <button
      type="button"
      {...props}
      aria-busy={loading}
      disabled={loading || props.disabled}
      className={twMerge(
        'flex h-fit w-fit items-center gap-2 whitespace-nowrap rounded-[8px] px-[16px] py-[8px] font-[600] text-primary transition-all hover:bg-opacity-80 hover:text-opacity-80 disabled:opacity-20 disabled:hover:bg-opacity-100',
        variant ? classes[variant] : undefined,
        className,
      )}>
      {loading && (
        <svg className="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
        </svg>
      )}
      {children}
    </button>
  );
}
